import { Children, forwardRef, cloneElement } from 'react';
import { useDrawerContext } from '../../../contexts/drawer';

const DrawerTrigger = forwardRef((props, ref) => {
  const { children, ...rest } = props;
  const { triggerProps } = useDrawerContext();

  return cloneElement(Children.only(children), triggerProps(ref, rest));
});

export default DrawerTrigger;
